<template>
    <div>
      <div id="captcha-element"></div>
    </div>
  </template>
    
  <script>
  export default {
    props: {
      buttonId:String,
      captchaWidth:Number,
      captchaHeight:Number,
    },
    data() {
      return {
          captcha:""
      };
    },
    mounted() {
      initAliyunCaptcha({
        SceneId: "ldi3kxxj1", // 场景ID。通过步骤一添加验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        prefix: "abq3480", // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
        mode: "embed", // 验证码模式。embed表示要集成的验证码模式为嵌入式。无需修改
        element: "#captcha-element", // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: "#"+this.buttonId, // 触发业务请求的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
        onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
        getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
        slideStyle: {
          width: this.captchaWidth || 320,
          height: this.captchaHeight || 40,
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: this.locale_lang=='zh-HK'?"tw":'en', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
        immediate: true, // 完成验证后，是否立即发送验证请求（调用captchaVerifyCallback函数）
        region: "cn", //验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）
      });
    },
    beforeUnmount() {},
    methods: {
      getInstance(instance) {
        this.captcha = instance;
      },
  
      captchaVerifyCallback(captchaVerifyParam) {
        console.log("captchaVerifyCallback", "滑动了，可以获取验证码");
  
        // 2.构造标准返回参数
        const verifyResult = {
          captchaResult: true, // 验证码验证是否通过，boolean类型，必选
          bizResult: "", // 业务验证是否通过，boolean类型，可选，若为无业务验证结果的场景，bizResult可以为空
          captcha:captchaVerifyParam
        };
        try {
        const inputs = document.querySelectorAll('input');
        inputs.forEach(input => input.blur());
      } catch (error) {
        
      }
        this.$emit('captchaVerifyCallback',verifyResult)
        return verifyResult
      },
      onBizResultCallback(bizResult) {
        console.log("onBizResultCallback");
      //   if (bizResult === true) {
      //     // 如果业务验证通过，跳转到对应页面。此处以跳转到https://www.aliyun.com/页面为例
      //     window.location.href = "https://www.aliyun.com/";
      //   } else {
      //     // 如果业务验证不通过，给出不通过提示。此处不通过提示为业务验证不通过！
      //     console.logrt("业务验证不通过！");
      //   }
      },
    },
  };
  </script>
    
  <style scoped>
  ::v-deep #aliyunCaptcha-sliding-wrapper #aliyunCaptcha-sliding-body #aliyunCaptcha-sliding-slider {
    background: #7f7f7f !important; ;
  }
  ::v-deep #aliyunCaptcha-window-embed {
    z-index: 20;
  }
  </style>